module.exports = __webpack_public_path__ + "assets/organization.428cc570.svg";